export default "__VITE_ASSET__892d4f06__"